import isMappingUpdated from './isMappingUpdated';
import _get from 'lodash/get';

// Interfaces
import MappingProps, { MappingTypes } from 'types/Mapping';

interface CustomMappingProps {
  createdAt?: string;
  destination: string;
  id?: string;
  isRequired: boolean;
  isUnique: boolean;
  source: string;
  sourceId?: string;
  type: MappingTypes;
  fromAttributeHeader?: boolean;
  customProps: any;
}

export default function createDataBatchActions(
  initialMappings: MappingProps[],
  submittedMappings: CustomMappingProps[],
  sourceId: string,
) {
  const batchActions: any[] = [];

  initialMappings.forEach((im: MappingProps) => {
    const submittedMapping = submittedMappings.find(sm => im.id === sm.id);

    // Find all initialMappings that don't exist in submittedMappings
    if (!im.fromAttributeHeader && (!submittedMapping || !submittedMapping.destination)) {
      batchActions.push({ type: 'destroy', id: im.id });
    }

    // // Find all submittedMappings with mismatch destinations and sources
    if (submittedMapping && !im.fromAttributeHeader) {
      const changesWereMadeToMapping = isMappingUpdated(im, submittedMapping);
      if (changesWereMadeToMapping) {
        const { id, source, createdAt, customProps, ...smData } = submittedMapping;

        id &&
          batchActions.push({
            type: 'update',
            id,
            data: {
              ...smData,
              collectionItemCustomType: _get(submittedMapping, `collectionItemCustomType`) || null,
              collectionItemType: _get(submittedMapping, `collectionItemType`) || null,
              source: _get(submittedMapping, `customProps.mappingSubSource`, source),
              sourceId,
            },
          });
      }
    }
  });

  // Find all submittedMappings without IDs
  submittedMappings.forEach(sm => {
    const { id, createdAt, fromAttributeHeader, source, customProps, ...smData } = sm;
    if (!id) {
      batchActions.push({
        type: 'create',
        data: {
          ...smData,
          collectionItemCustomType: _get(sm, `collectionItemCustomType`) || null,
          collectionItemType: _get(sm, `collectionItemType`) || null,
          source: _get(sm, `customProps.mappingSubSource`, source),
          sourceId,
        },
      });
    }
  });

  const destroyActions = batchActions.filter(action => action.type === 'destroy' && !!action.id);
  const otherValidActions = batchActions.filter(
    action => !!_get(action, ['data', 'destination']) && !!_get(action, ['data', 'source']),
  );

  return [...destroyActions, ...otherValidActions];
}
